var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(!_vm.underlined)?_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_c('div',{staticClass:"title underlined"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('body',{staticClass:"section-body"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }